

import React, { useEffect, useState } from "react";
import { getAllPolls, updatePoll,deletePoll, getPollResults } from "../../../services/adminService";
import {
  getCategories,
  getSubcategories,
  getCountries,
  getStatesByCountry,
  getCitiesByState,
} from "../../../services/apiService";
import { Modal, Button, Form } from "react-bootstrap";
import { Box, IconButton, Switch, TableCell } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
const PollList = () => {
  const [polls, setPolls] = useState([]);
  const [selectedPoll, setSelectedPoll] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [results, setResults] = useState(null);
const [showResults, setShowResults] = useState(false);

const handleViewResults = async (pollId) => {
  try {
    const res = await getPollResults(pollId);
    setResults(res.data); // backend से आने वाला {question, totalVotes, results}
    setShowResults(true);
  } catch (err) {
    console.error("Error fetching results:", err);
    alert("Failed to fetch results");
  }
};
  // ✅ Fetch Polls
  const fetchPolls = async () => {
    try {
      const res = await getAllPolls();
      setPolls(res.data);
    } catch (err) {
      console.error("Error fetching polls:", err);
    }
  };

  useEffect(() => {
    fetchPolls();
    loadCategories();
    loadCountries();
  }, []);

  // ✅ Load dropdowns
  const loadCategories = async () => {
    const res = await getCategories();
    setCategories(res.data);
  };
  const loadSubcategories = async (catId) => {
    if (!catId) return setSubcategories([]);
    const res = await getSubcategories(catId);
    setSubcategories(res.data);
  };
  const loadCountries = async () => {
    const res = await getCountries();
    setCountries(res.data);
  };
  const loadStates = async (countryId) => {
    if (!countryId) return setStates([]);
    const res = await getStatesByCountry(countryId);
    setStates(res.data);
  };
  const loadCities = async (stateId) => {
    if (!stateId) return setCities([]);
    const res = await getCitiesByState(stateId);
    setCities(res.data);
  };

  // ✅ Open modal with poll data
  const handleEdit = (poll) => {
    setSelectedPoll(poll);

    if (poll.category?._id) loadSubcategories(poll.category._id);
    if (poll.country?._id) loadStates(poll.country._id);
    if (poll.state?._id) loadCities(poll.state._id);

    setShowModal(true);
  };

    const handleToggleStatus = async (pollId, currentStatus) => {
    try {
      // call API
      await updatePoll(pollId, { isActive: !currentStatus });
      // update local state
      setPolls((prev) =>
        prev.map((p) =>
          p._id === pollId ? { ...p, isActive: !currentStatus } : p
        )
      );
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

   const handleDelete = async (pollId) => {
    if (!window.confirm("Are you sure you want to delete this poll?")) return;
    try {
      await deletePoll(pollId);
      setPolls((prev) => prev.filter((poll) => poll._id !== pollId));
    } catch (error) {
      console.error("Error deleting poll:", error);
    }
  };

  // ✅ Update poll
  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      const updatedPoll = {
        question: selectedPoll.question,
        options: selectedPoll.options.map((opt) => ({
          text: opt.text.trim(),
          votes: opt.votes || 0,
        })),
        start_date: selectedPoll.start_date,
        end_date: selectedPoll.end_date,
        visibility: selectedPoll.visibility,
        isActive: selectedPoll.isActive,
        category: selectedPoll.category?._id,
        subCategory: selectedPoll.subCategory?._id,
        country: selectedPoll.country?._id,
        state: selectedPoll.state?._id,
        city: selectedPoll.city?._id,
      };

      await updatePoll(selectedPoll._id, updatedPoll);
      setShowModal(false);
      fetchPolls();
    } catch (err) {
      console.error("Error updating poll:", err);
    }
  };

  return (
    <div className="container mt-4">
      <h3>Poll Management</h3>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>#No</th>
            <th>Question</th>
            <th>Options</th>
            <th>Category</th>
            <th>SubCategory</th>
            {/* <th>State</th>
               <th>City</th>
             */}
            <th>Visibility</th>
            <th>Status</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Actions</th>
            
          </tr>
        </thead>
        <tbody>
          {polls.map((poll,index) => (
            <tr key={poll._id}>
                   <td>{index + 1}</td>
              <td>{poll.question}</td>
              <td>{poll.options.map((o) => o.text).join(", ")}</td>
              <td>{poll.category?.name}</td>
              <td>{poll.subCategory?.name}</td>
               {/* <td>{poll.state?.name}</td>
              <td>{poll.city?.name}</td> */}
              <td>{poll.visibility}</td>
           <TableCell>
              <Switch
                checked={poll.isActive}
                onChange={() => handleToggleStatus(poll._id, poll.isActive)}
                color="primary"
              />
            </TableCell>
              <td>{poll.start_date?.split("T")[0]}</td>
              <td>{poll.end_date?.split("T")[0]}</td>
            <TableCell>
  <Box display="flex" alignItems="center" gap={1}>
    <IconButton
      color="warning"
      size="small"
      onClick={() => handleEdit(poll)}
    >
      <EditIcon />
    </IconButton>

    <IconButton
      color="error"
      size="small"
      onClick={() => handleDelete(poll._id)}
    >
      <DeleteIcon />


    </IconButton>
    <IconButton
  color="primary"
  size="small"
  onClick={() => handleViewResults(poll._id)}
>
  📊
</IconButton>

  </Box>
</TableCell>
            </tr>
          ))}
        </tbody>
      </table>

<Modal show={showResults} onHide={() => setShowResults(false)} size="lg">
  <Modal.Header closeButton>
    <Modal.Title>📊 Poll Results</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {results ? (
      <>
        <h5>{results.question}</h5>
        <p><b>Total Votes:</b> {results.totalVotes}</p>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Option</th>
              <th>Votes</th>
              <th>Percentage</th>
            </tr>
          </thead>
          <tbody>
            {results.results.map((opt, idx) => (
              <tr key={idx}>
                <td>{opt.text}</td>
                <td>{opt.votes}</td>
                <td>
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        width: `${opt.percentage}%`,
                        backgroundColor: "#007bff",
                        color: "white",
                        textAlign: "center",
                        borderRadius: "4px",
                      }}
                    >
                      {opt.percentage}%
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </>
    ) : (
      <p>No results available.</p>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowResults(false)}>
      Close
    </Button>
  </Modal.Footer>
</Modal>

      {/* Update Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg"   style={{ marginTop: '50px' }} >
        <Modal.Header closeButton>
          <Modal.Title>Update Poll</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedPoll && (
            <Form onSubmit={handleUpdate}>
              {/* Question */}
              <Form.Group>
                <Form.Label>Question</Form.Label>
                <Form.Control
                  type="text"
                  value={selectedPoll.question}
                  onChange={(e) =>
                    setSelectedPoll({ ...selectedPoll, question: e.target.value })
                  }
                />
              </Form.Group>

              {/* Options */}
              <Form.Group className="mt-2">
                <Form.Label>Options</Form.Label>
                {selectedPoll.options.map((opt, idx) => (
                  <div key={idx} className="d-flex align-items-center mb-2">
                    <Form.Control
                      type="text"
                      value={opt.text}
                      onChange={(e) => {
                        const updatedOptions = [...selectedPoll.options];
                        updatedOptions[idx].text = e.target.value;
                        setSelectedPoll({ ...selectedPoll, options: updatedOptions });
                      }}
                    />
                    <Button
                      variant="danger"
                      size="sm"
                      className="ms-2"
                      onClick={() => {
                        const updatedOptions = selectedPoll.options.filter(
                          (_, i) => i !== idx
                        );
                        setSelectedPoll({ ...selectedPoll, options: updatedOptions });
                      }}
                    >
                      ✕
                    </Button>
                  </div>
                ))}
                <Button
                  variant="success"
                  size="sm"
                  className="mt-2"
                  onClick={() =>
                    setSelectedPoll({
                      ...selectedPoll,
                      options: [...selectedPoll.options, { text: "", votes: 0 }],
                    })
                  }
                >
                  ➕ Add Option
                </Button>
              </Form.Group>

              {/* Dates */}
              <Form.Group className="mt-2">
                <Form.Label>Start Date</Form.Label>
                <Form.Control
                  type="date"
                  value={selectedPoll.start_date?.split("T")[0] || ""}
                  onChange={(e) =>
                    setSelectedPoll({ ...selectedPoll, start_date: e.target.value })
                  }
                />
              </Form.Group>
              <Form.Group className="mt-2">
                <Form.Label>End Date</Form.Label>
                <Form.Control
                  type="date"
                  value={selectedPoll.end_date?.split("T")[0] || ""}
                  onChange={(e) =>
                    setSelectedPoll({ ...selectedPoll, end_date: e.target.value })
                  }
                />
              </Form.Group>

              {/* Visibility */}
              <Form.Group className="mt-2">
                <Form.Label>Visibility</Form.Label>
                <Form.Select
                  value={selectedPoll.visibility}
                  onChange={(e) =>
                    setSelectedPoll({ ...selectedPoll, visibility: e.target.value })
                  }
                >
                  <option value="public">Public</option>
                  <option value="registered">Registered Users</option>
                </Form.Select>
              </Form.Group>

              {/* Status */}
              <Form.Group className="mt-2">
                <Form.Check
                  type="switch"
                  id="isActiveSwitch"
                  label="Poll Active"
                  checked={selectedPoll.isActive}
                  onChange={(e) =>
                    setSelectedPoll({ ...selectedPoll, isActive: e.target.checked })
                  }
                />
              </Form.Group>

              {/* Category */}
              <Form.Group className="mt-2">
                <Form.Label>Category</Form.Label>
                <Form.Select
                  value={selectedPoll.category?._id || ""}
                  onChange={(e) => {
                    setSelectedPoll({
                      ...selectedPoll,
                      category: { _id: e.target.value },
                      subCategory: null,
                    });
                    loadSubcategories(e.target.value);
                  }}
                >
                  <option value="">Select Category</option>
                  {categories.map((cat) => (
                    <option key={cat._id} value={cat._id}>
                      {cat.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              {/* SubCategory */}
              <Form.Group className="mt-2">
                <Form.Label>SubCategory</Form.Label>
                <Form.Select
                  value={selectedPoll.subCategory?._id || ""}
                  onChange={(e) =>
                    setSelectedPoll({
                      ...selectedPoll,
                      subCategory: { _id: e.target.value },
                    })
                  }
                >
                  <option value="">Select SubCategory</option>
                  {subcategories.map((sub) => (
                    <option key={sub._id} value={sub._id}>
                      {sub.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              {/* Location: Country / State / City */}
              <Form.Group className="mt-2">
                <Form.Label>Country</Form.Label>
                <Form.Select
                  value={selectedPoll.country?._id || ""}
                  onChange={(e) => {
                    setSelectedPoll({
                      ...selectedPoll,
                      country: { _id: e.target.value },
                      state: null,
                      city: null,
                    });
                    loadStates(e.target.value);
                  }}
                >
                  <option value="">Select Country</option>
                  {countries.map((c) => (
                    <option key={c._id} value={c._id}>
                      {c.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mt-2">
                <Form.Label>State</Form.Label>
                <Form.Select
                  value={selectedPoll.state?._id || ""}
                  onChange={(e) => {
                    setSelectedPoll({
                      ...selectedPoll,
                      state: { _id: e.target.value },
                      city: null,
                    });
                    loadCities(e.target.value);
                  }}
                >
                  <option value="">Select State</option>
                  {states.map((s) => (
                    <option key={s._id} value={s._id}>
                      {s.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mt-2">
                <Form.Label>City</Form.Label>
                <Form.Select
                  value={selectedPoll.city?._id || ""}
                  onChange={(e) =>
                    setSelectedPoll({
                      ...selectedPoll,
                      city: { _id: e.target.value },
                    })
                  }
                >
                  <option value="">Select City</option>
                  {cities.map((c) => (
                    <option key={c._id} value={c._id}>
                      {c.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Button className="mt-3" variant="primary" type="submit">
                Save Changes
              </Button>
            </Form>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default PollList; 